import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'flx-card-footer',
	templateUrl: './card-footer.component.html',
	styleUrls: ['./card-footer.component.scss']
})
export class FLXCardFooterComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
